<div class="modal-header">
  <div>
    <h4 class="modal-title" id="exampleModalLabel">
      {{ "LPOptions.update" | translate }}
      <b>{{ locationPartner.companyName }}</b>
    </h4>
    <h5 class="m-b-0 m-t-10">
      {{ "enumMapping.updateLPcards." + selectedOption.toString() | translate }}
    </h5>
  </div>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="onClickCloseModal()"
  ></button>
</div>
<div class="modal-body p-b-0">
  <form class="form theme-form" [formGroup]="personalInformation">
    <div
      *ngIf="
        selectedOption == step.ADMIN_UPDATE_LOCATION_PERSONNELLE_INFORMATION
      "
    >
      <div class="form-group">
        <label class="label"
          >{{ "addLP.firstStep.firstName" | translate }} *</label
        >
        <div class="input-group">
          <input
            formControlName="firstName"
            class="form-control"
            type="text"
            required=""
            [placeholder]="'profile.profileDetails.firstName' | translate"
            [ngClass]="{
              'is-invalid':
                !personalInformation.get('firstName')?.valid &&
                personalInformation.get('firstName')?.touched
            }"
          />
          <div
            class="invalid-feedback"
            *ngIf="
              !personalInformation.get('firstName')?.valid &&
              personalInformation.get('firstName')?.touched
            "
          >
            {{ "validation.firstName" | translate }}
          </div>
        </div>
      </div>
      <div class="form-group">
        <label class="label"
          >{{ "addLP.firstStep.lastName" | translate }} *</label
        >
        <div class="input-group">
          <input
            formControlName="lastName"
            class="form-control"
            type="text"
            required=""
            [placeholder]="'profile.profileDetails.lastName' | translate"
            [ngClass]="{
              'is-invalid':
                !personalInformation.get('lastName')?.valid &&
                personalInformation.get('lastName')?.touched
            }"
          />
          <div
            class="invalid-feedback"
            *ngIf="
              !personalInformation.get('lastName')?.valid &&
              personalInformation.get('lastName')?.touched
            "
          >
            {{ "validation.lastName" | translate }}
          </div>
        </div>
      </div>
      <div class="form-group">
        <label class="label">{{ "addLP.firstStep.email" | translate }} *</label>
        <div class="input-group">
          <input
            formControlName="email"
            class="form-control"
            type="email"
            appNoSpaces
            required=""
            appIgnorePasswordManagers
            [placeholder]="'profile.profileDetails.email' | translate"
            [ngClass]="{
              'is-invalid':
                !personalInformation.get('email')?.valid &&
                personalInformation.get('email')?.touched
            }"
          />
          <div
            class="invalid-feedback"
            *ngIf="
              !personalInformation.get('email')?.valid &&
              personalInformation.get('email')?.touched
            "
          >
            {{ "validation.email" | translate }}
          </div>
        </div>
      </div>
      <div class="form-group">
        <label class="label"
          >{{ "addLP.secondStep.companyPhone" | translate }} *</label
        >
        <div class="input-group">
          <input
            formControlName="phone"
            class="form-control m-input digits"
            type="text"
            [mask]="'99 999 999'"
            required
            [placeholder]="'addLP.secondStep.companyPhone' | translate"
            [ngClass]="{
              'is-invalid':
                !personalInformation.get('phone')?.valid &&
                personalInformation.get('phone')?.touched
            }"
          />
          <div
            class="invalid-feedback"
            *ngIf="
              !personalInformation.get('phone')?.valid && personalInformation.get('phone')?.touched
            "
          >
            {{ "validation.phone" | translate }}
          </div>
        </div>
      </div>
      <div class="form-group">
        <label class="label">{{ "addLP.secondStep.role" | translate }} *</label>
        <div class="input-group">
          <input
            class="form-control"
            type="text"
            formControlName="companyRole"
            required
            [placeholder]="'addLP.secondStep.role' | translate"
            [ngClass]="{
              'is-invalid':
                !personalInformation.get('companyRole')?.valid && personalInformation.get('companyRole')?.touched
            }"
          />
          <div
            class="invalid-feedback"
            *ngIf="
              !personalInformation.get('companyRole')?.valid && personalInformation.get('companyRole')?.touched
            "
          >
            {{ "validation.companyRole" | translate }}
          </div>
        </div>
      </div>
    </div>
  </form>
  <form class="form theme-form" [formGroup]="companyInformation">
    <div
      *ngIf="selectedOption == step.ADMIN_UPDATE_LOCATION_COMPANY_SPECIFICATION"
    >
      <app-company-information
        [create]="false"
        [form]="companyInformation! | asFormGroup"
        [file]="getFileName()"
      ></app-company-information>
    </div>
  </form>
  <form class="form theme-form" [formGroup]="locationInformation">
    <div
      *ngIf="selectedOption == step.ADMIN_UPDATE_LOCATION_LOCATION_INFORMATION"
    >
      <app-location-information
        [isUpdate]="true"
        [form]="locationInformation! | asFormGroup"
      ></app-location-information>
    </div>
  </form>
  <form class="form theme-form" [formGroup]="partnerStatus">
    <div
      *ngIf="
        selectedOption == step.ADMIN_UPDATE_LOCATION_PARTNER_STATUS_INFORMATION
      "
    >
      <app-location-status
        [isUpdate]="true"
        [form]="partnerStatus! | asFormGroup"
        [isArchived]="!!locationPartner.archivedDate"
      ></app-location-status>
    </div>
  </form>
  <form class="form theme-form" [formGroup]="partnerStatus">
    <div
      *ngIf="
        selectedOption == step.ADMIN_UPDATE_LOCATION_PARTNER_ROUTER_INFORMATION
      "
    >
      <app-router-information [form]="routerInformation"></app-router-information>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button class="btn btn-outline-primary" (click)="onClickBack()">
    {{ "buttons.return" | translate }}
  </button>
  <button
    class="btn btn-primary button-right"
    type="submit"
    (click)="saveChanges()"
    [disabled]="isDisableButton()"
  >
    {{ "buttons.confirm" | translate }}
  </button>
</div>
